// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"524":"c744f260a35bd795","794":"8a260f49578f6f8e"}[chunkId] + ".js";
};